import GlobalForm from "../../../global/components/GlobalForm";

export default function ContactMe() {
    const formEntries = [
        {
            entry: "name",
            rows: "1"
        },
        {
            entry: "email",
            rows: "1"
        },
        {
            entry: "message",
            rows: "6"
        }
    ]

  return (
    <div className="portfolio-container pb-5">
        <div className="container max-w-md mx-auto contact-me">
            <p className="text-gray-300 text-center">Ready to build something revolutionary?</p>
            <h1>Contact Me</h1>
            <GlobalForm formEntries={formEntries} endpoint='/contact/' sendButton='Send Message'/>
        </div>
    </div>
  )
}
